<!--  -->
<template>
    <popover v-model="visiable" trigger="click" theme="dark">
        <grid square clickable :border="false" column-num="3" style="width: 180px;padding:10px">
            {{info}}
        </grid>
        <template #reference>
            <span class="flex">
                <van-icon name="question-o" size='18' />

            </span>
        </template>
    </popover>
</template>

<script>
import { Popover, Grid } from 'vant'
export default {
    name: 'Info',
    components: {
        Popover,
        Grid
    },
    props: {
        info: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            visiable: false
        }
    },

    computed: {},

    mounted() { },

    methods: {}
}

</script>
<style scoped>
img {
    width: 32px;
    height: 32px;
}

.flex {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
